import * as BN from 'bn.js';
import { CurrencyType, ItemType } from '../types';
import { tokenDecimals, SYSTEM_DECIMALS, currencyName } from './config';
export { SYSTEM_DECIMALS } from './config';
export const serverCurrencyToSystemCurrency = currency => {
  const {
    type,
    value
  } = currency || {};

  if (typeof type !== 'number' && typeof value !== 'number') {
    throw new Error('Unrecoginzed currency value');
  }

  if (!Object.values(CurrencyType).includes(type)) {
    throw new Error('Unrecoginzed currency token');
  }

  return {
    token: type,
    value: new BN.BN(value).toString()
  };
};
export const serverItemToSystemItem = currency => {
  const {
    type,
    amount,
    decimals
  } = currency || {};

  if (typeof type !== 'number' && typeof amount !== 'number') {
    throw new Error('Unrecognized Item value');
  }

  if (!Object.values(ItemType).includes(type)) {
    throw new Error('Unrecognized Item token');
  }

  return {
    token: type,
    value: new BN.BN(amount).toString(),
    decimals: typeof decimals === 'number' ? decimals : 0
  };
};
export const unsafeServerCurrencyToSystemCurrency = currency => {
  const {
    type,
    value
  } = currency || {};

  if (typeof type !== 'number' && typeof value !== 'number') {
    throw new Error('Unrecognized currency value');
  }

  if (!Object.values(CurrencyType).includes(type)) {
    throw new Error('Unrecognized currency token');
  }

  return {
    token: type,
    value: new BN.BN(String(value)).toString()
  };
};
export const systemCurrencyToServerCurrency = currency => {
  const {
    token,
    value
  } = currency;
  return {
    type: token,
    value: parseInt(value),
    decimals: 8,
    name: currencyName[token]
  };
};
export const systemItemToServerItem = item => {
  const {
    token,
    value,
    decimals
  } = item;
  return {
    type: token,
    amount: parseInt(value, 10),
    decimals: decimals,
    kind: 1
  };
};
export const blockchainNumberToSystemCurrency = (token, value) => {
  const decimals = tokenDecimals[token];
  const useMultiply = SYSTEM_DECIMALS >= decimals;
  const multiplier = new BN.BN( // construct 10^x as string form
  ['1', ...new Array(Math.abs(SYSTEM_DECIMALS - decimals)).fill('0')].join(''));
  const parsedValue = useMultiply ? value.mul(multiplier) : value.div(multiplier);
  return {
    token,
    value: parsedValue.toString()
  };
};
export const systemCurrencyToBlockchainNumber = currency => {
  const {
    value,
    token
  } = currency;
  const valueBN = new BN.BN(value);
  const decimals = tokenDecimals[token];
  const useMultiply = SYSTEM_DECIMALS <= decimals;
  const multiplier = new BN.BN( // construct 10^x as string form
  ['1', ...new Array(Math.abs(decimals - SYSTEM_DECIMALS)).fill('0')].join(''));
  const parsedValue = useMultiply ? valueBN.mul(multiplier).toString() : valueBN.div(multiplier).toString();
  return parsedValue;
};
export const normalNumberToSystemCurrency = (value, token) => {
  const valueBN = new BN(Math.floor(value * Math.pow(10, SYSTEM_DECIMALS)).toLocaleString('fullwide', {
    useGrouping: false
  }));
  return {
    token,
    value: valueBN.toString()
  };
};